// extracted by mini-css-extract-plugin
module.exports = {"selected-old-customer-and-new-customer":"selected-old-customer-and-new-customer-5765318f588eb3c05cddb8d99a0def9d"};